export default __webpack_public_path__ + "static/media/markit_logo.cc3cba9f.png";